const defaultConfigName = 'global-crf-prod';
//const defaultConfigName = 'global-crf-test';
module.exports = defaultConfigName;
